export class AppError {
    constructor (public originalError? : any) {}
}
//hi team